import { render } from "./nav-activities-icon.svg?vue&type=template&id=702434c0"
import script from "./nav-activities-icon.svg?vue&type=script&lang=js"
export * from "./nav-activities-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src539/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__